// extracted by mini-css-extract-plugin
module.exports = {"container":"nav_folders-module__container--2RPgJ"};